<template>
  <div
    v-if="issueDataInfo"
    ref="viewIssuePopupModal"
    class="modal fade issue-popup-container"
    tabindex="-1"
    role="dialog"
    :id="`issue-popup${complaintId}${tabName}`"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header new-design text-left">
          <h5 class="modal-title d-inline">
            {{ issueDataInfo.complaint_num }}
            <div class="btn-group pair_btn_new_uniq">
              <button
                data-toggle="dropdown"
                data-too="tooltip"
                data-placement="bottom"
                aria-haspopup="true"
                aria-expanded="false"
                class="btn btn-default dropdown-toggle create-btn FontSize"
              >
                <i
                  class="fa fa-ellipsis-v"
                  style="color: rgba(138, 138, 138, 1); font-size: 18px"
                ></i>
              </button>
              <ul
                class="dropdown-menu pair_of_all_li w_und_767"
                id="pair_of_all_li"
              >
                <li>
                  <a
                    href="#"
                    data-toggle="modal"
                    data-target="#popupi"
                    @click="
                      IssueDiscussionPopup(
                        complaintId,
                        issueDataInfo.process1,
                        issueDataInfo.process2
                      )
                    "
                    class="details_info_opt"
                  >
                    <!--                                        <span><i class="fa fa-edit"></i></span>-->
                    <span>Convert issue status</span>
                  </a>
                </li>
                <li
                  v-if="
                    issueDataInfo.complaintConvertStatusCredential &&
                    ((issueDataInfo.complaint_status_row || {}).name ===
                      'NEW' ||
                      (issueDataInfo.complaint_status_row || {}).name ===
                        'IN PROGRESS' ||
                      (issueDataInfo.complaint_status_row || {}).name ===
                        'REOPENED')
                  "
                >
                  <a
                    href="#"
                    data-toggle="modal"
                    data-target="#popupi"
                    @click="IssueDiscussionPopup(complaintId, 'Close')"
                    class="details_info_opt"
                  >
                    <span>Close issue</span>
                  </a>
                </li>
                <li v-if="issueDataInfo.complaintDiscussionCredential">
                  <a
                    href="#"
                    data-toggle="modal"
                    data-target="#popupi"
                    @click="IssueDiscussionPopup(complaintId, 'send')"
                    class="details_info_opt"
                  >
                    <!--                                        <span><i class="fa fa-edit"></i></span>-->
                    <span>Add discussions</span>
                  </a>
                </li>
                <li v-if="issueDataInfo.complaintDiscussionCredential">
                  <a
                    href="#"
                    data-toggle="modal"
                    data-target="#popupi"
                    @click="IssueDiscussionPopup(complaintId, 'send')"
                    class="details_info_opt"
                  >
                    <!--                                        <span><i class="fa fa-edit"></i></span>-->
                    <span>Add attachments</span>
                  </a>
                </li>

                <li v-if="issueDataInfo.complaintEmailReplayCredential">
                  <a
                    href="#"
                    data-toggle="modal"
                    data-target="#popupi"
                    @click="
                      complaintEmailReplay(
                        complaintId,
                        issueDataInfo.complaint_booking_row.customer_id
                      )
                    "
                    class="details_info_opt"
                  >
                    <!--                                        <span><i class="fa fa-edit"></i></span>-->
                    <span>Email Acknowledgment to Customer</span>
                  </a>
                </li>
                <li v-if="issueDataInfo.complaintDeleteCredential">
                  <a
                    href="javascript:;"
                    data-toggle="modal"
                    :data-target="`#delete-issue-confirmation${complaintId}`"
                    class="details_info_opt"
                  >
                    <!--                                        <span><i class="fa fa-edit"></i></span>-->
                    <span>Delete forever</span>
                  </a>

                  <confirmation-popup
                    title="Confirm delete forever"
                    :message="`Are you sure you want to delete the selected complaint forever?<br> Please note that this will delete all photos and other attachments uploaded for all selected Complaint, including photos uploaded to the complaint chat discussions.`"
                    :id="`delete-issue-confirmation${complaintId}`"
                    confirm-btn-text="Delete forever"
                    cancel-btn-text="Cancel"
                    @on-confirm="deleteForEver(complaintId)"
                  ></confirmation-popup>
                </li>
              </ul>
            </div>
          </h5>
          <svg
            class="close-icon clickable"
            @click.stop="closeModal"
            data-dismiss="modal"
            aria-label="Close"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 10.59L15.59 7L17 8.41L13.41 12L17 15.59L15.59 17L12 13.41L8.41 17L7 15.59L10.59 12L7 8.41L8.41 7L12 10.59Z"
              fill="#2E4051"
            />
          </svg>
        </div>

        <div class="modal-body">
          <div class="row status-content">
            <div class="col-md-12 p-bottom-15">
              <div class="col-md-3">
                <span class="booking_title">Status</span>
              </div>
              <div class="col-md-9">
                <a
                  data-toggle="dropdown"
                  data-too="tooltip"
                  data-placement="bottom"
                  aria-haspopup="true"
                  aria-expanded="false"
                  class="dropdown-toggle FontSize text-decoration-none"
                >
                  <span
                    :class="{
                      'status-label labels-font font-family-Roboto cursor-pointer position-relative top-4': true,
                    }"
                    :style="color"
                    v-if="issueDataInfo"
                  >
                    {{ (issueDataInfo.complaint_status_row || {}).name }}
                  </span>
                </a>
                <ul
                  class="dropdown-menu pair_of_all_li w_und_767"
                  id="pair_of_all_li"
                >
                  <li
                    v-if="
                      issueDataInfo.complaintConvertStatusCredential &&
                      ((issueDataInfo.complaint_status_row || {}).name ===
                        'NEW' ||
                        (issueDataInfo.complaint_status_row || {}).name ===
                          'IN PROGRESS' ||
                        (issueDataInfo.complaint_status_row || {}).name ===
                          'REOPENED')
                    "
                  >
                    <a
                      href="#"
                      data-toggle="modal"
                      data-target="#popupi"
                      @click="IssueDiscussionPopup(complaintId, 'Close')"
                      class="details_info_opt"
                    >
                      <span>Close issue</span>
                    </a>
                  </li>

                  <li
                    v-if="
                      issueDataInfo.complaintConvertStatusCredential &&
                      issueDataInfo.process1 !== 'no_process'
                    "
                  >
                    <a
                      href="#"
                      data-toggle="modal"
                      data-target="#popupi"
                      @click="
                        IssueDiscussionPopup(
                          complaintId,
                          issueDataInfo.process1
                        )
                      "
                      class="details_info_opt"
                    >
                      <!--      <span><i class="fa fa-edit"></i></span>-->
                      <span>{{
                        issueDataInfo.process1.replace(/\+/g, " ")
                      }}</span>
                    </a>
                  </li>
                </ul>

                <span
                  v-if="
                    issueDataInfo.canApproveComplaintCredential &&
                    (issueDataInfo.complaint_status_row || {}).name ===
                      'AWAITING APPROVAL'
                  "
                >
                  Approve
                  <label class="figma-switch float-right-mobile">
                    <input
                      id="is_approved"
                      :checked="issueDataInfo.is_approved"
                      type="checkbox"
                      @change="
                        issueEditWithParamFunction(
                          'is_approved',
                          issueDataInfo.is_to_follow - 1
                        )
                      "
                    />
                    <span for="is_approved" class="slider round"> </span>
                  </label>
                </span>
              </div>
            </div>
            <div class="col-md-12 p-bottom-15">
              <div class="col-md-3">
                <span class="booking_title">Created</span>
              </div>
              <div class="col-md-9 booking_item">
                <span>{{ issueDataInfo.created }}</span> by
                <span
                  v-if="
                    issueDataInfo.created_by.user_id == issueDataInfo.user_id
                  "
                  class="color-blue"
                >
                  You
                </span>
                <span v-else>
                  {{ issueDataInfo.created_by.username }}
                </span>
              </div>
            </div>
            <div class="col-md-12 p-bottom-15">
              <div class="col-md-3">
                <span class="booking_title">Booking</span>
              </div>
              <div class="col-md-9 booking_item">
                <span>{{
                  issueDataInfo.complaint_booking_row.booking_num
                }}</span>
                <span
                  :class="{
                    'status-label labels-font font-family-Roboto m-right-5': true,
                  }"
                  :style="`background-color: ${issueDataInfo.complaint_booking_status_row.color}`"
                >
                  {{ issueDataInfo.complaint_booking_status_row.name }}
                </span>
              </div>
            </div>
            <div class="col-md-12 p-bottom-15">
              <div class="col-md-3">
                <span class="booking_title">Invoice</span>
              </div>
              <div class="col-md-9 booking_item">
                <a
                  class="text-decoration-none"
                  data-toggle="modal"
                  :data-target="`#invoice-popup${issueDataInfo.booking_id}${complaintId}`"
                  >{{ issueDataInfo.complaint_invoice_row.invoice_num }}</a
                >
                <payment-invoice-popup
                  :booking-id-prop="issueDataInfo.booking_id"
                  :invoice-id-prop="issueDataInfo.complaint_invoice_row.id"
                  merged-invoice-id-prop="0"
                  :from-issue-page="complaintId"
                >
                </payment-invoice-popup>
                <span
                  :class="{
                    'status-label labels-font font-family-Roboto m-right-5 position-status-invoice-modal cursor-pointer': true,
                  }"
                  :style="`background-color:${issueDataInfo.complaint_invoice_row.style_color};color:#FFFFFF`"
                  data-toggle="modal"
                  data-target="#popupi"
                  @click="
                    Invoice_Preview_Data(issueDataInfo.complaint_invoice_row.id)
                  "
                >
                  {{ issueDataInfo.complaint_invoice_row.invoice_type }}
                </span>
              </div>
            </div>
            <div class="col-md-12 p-bottom-15">
              <div class="col-md-3">
                <span class="booking_title">Assignee</span>
              </div>
              <div class="col-md-9 booking_item">
                <select-owners
                  v-model="issueDataInfo.assignee_id"
                  :current-role="loggedUser.role_id"
                  :current-user="loggedUser.user_id"
                  :s3-path="s3Path"
                  :view-page="false"
                  :from-issue-page="true"
                  :complaint-id="complaintId"
                  :booking-id="issueDataInfo.bookingId"
                >
                </select-owners>
              </div>
            </div>
          </div>

          <form
            ref="issueEditForm"
            id="issueEditForm"
            autocomplete="off"
            class="form-horizontal"
            @submit.prevent="saveEditing()"
            enctype="multipart/form-data"
            method="post"
          >
            <div class="row p-top-25 p-left-10">
              <div class="col-md-12 p-left-0">
                <span class="reported-issue"> Reported issue </span>

                <span class="float-right">
                  <a @click="toggleEdit" class="icon-position" v-if="!editing">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.06 6.02L11.98 6.94L2.92 16H2V15.08L11.06 6.02ZM14.66 0C14.41 0 14.15 0.1 13.96 0.29L12.13 2.12L15.88 5.87L17.71 4.04C18.1 3.65 18.1 3.02 17.71 2.63L15.37 0.29C15.17 0.09 14.92 0 14.66 0ZM11.06 3.19L0 14.25V18H3.75L14.81 6.94L11.06 3.19Z"
                        fill="#2E4051"
                      />
                    </svg>
                  </a>
                  <a @click="toggleEdit" class="icon-position" v-else>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M10 0C4.47 0 0 4.47 0 10C0 15.53 4.47 20 10 20C15.53 20 20 15.53 20 10C20 4.47 15.53 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18ZM10 8.59L13.59 5L15 6.41L11.41 10L15 13.59L13.59 15L10 11.41L6.41 15L5 13.59L8.59 10L5 6.41L6.41 5L10 8.59Z"
                        fill="#2E4051"
                      />
                    </svg>
                  </a>
                </span>
              </div>

              <div
                class="col-md-12 p-left-0 p-top-15"
                v-if="allComplaintTypes.length !== 0"
              >
                <div class="col-md-12 p-left-0">
                  <span class="booking_title">Issue type</span>
                </div>
                <div class="col-md-12 p-left-0 booking_item">
                  <span :id="`issue_type${complaintId}`" v-if="!editing">
                    <span v-if="issueDataInfo.complaint_type.name">{{
                      issueDataInfo.complaint_type.name
                    }}</span>
                    <span v-else>---</span>
                  </span>
                  <select
                    v-else
                    name="complaint_type_id"
                    class="form-control arrow-style issue-type-select"
                  >
                    <option
                      v-if="allComplaintTypes.length !== 0"
                      v-for="(
                        complaintTypename, complaintTypeId
                      ) of allComplaintTypes"
                      :key="complaintTypeId"
                      :selected="
                        complaintTypeId == issueDataInfo.complaint_type_id
                          ? true
                          : false
                      "
                      :value="complaintTypeId"
                    >
                      {{ complaintTypename }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-md-12 p-left-0 p-top-15">
                <div class="col-md-12 p-left-0">
                  <span class="booking_title">Message</span>
                </div>
                <div class="col-md-12 p-left-0 booking_item">
                  <span v-if="!editing" :id="`${complaintId}_vue_comment_view`">
                    <label class="font-weight-400">
                      {{ issueDataInfo.comment }}
                    </label>
                  </span>
                  <span v-else>
                    <textarea
                      rows="4"
                      v-model="issueDataInfo.comment"
                      name="comment"
                      :id="`${complaintId}_vue_comment_input`"
                      class="textarea_field form-control m-bottom-5"
                    >
 {{ issueDataInfo.comment }} </textarea
                    >
                  </span>
                </div>
              </div>

              <div class="col-md-12 p-left-0 p-top-15">
                <div class="col-md-12 p-left-0">
                  <span class="booking_title">To Follow</span>
                </div>
                <div class="col-md-12 p-left-0 booking_item">
                  <label class="figma-switch float-right-mobile">
                    <input
                      id="is_to_follow"
                      :checked="issueDataInfo.is_to_follow"
                      type="checkbox"
                      disabled
                      v-if="!editing"
                    />
                    <input
                      id="is_to_follow"
                      :checked="issueDataInfo.is_to_follow"
                      type="checkbox"
                      v-model="issueDataInfo.is_to_follow"
                      name="is_to_follow"
                      v-else
                    />
                    <span for="is_to_follow" class="slider round"></span>
                  </label>
                </div>
              </div>

              <div class="col-md-12 p-left-0 p-top-15">
                <div class="col-md-12 p-left-0">
                  <span class="booking_title">Deferred Date</span>
                </div>
                <div class="col-md-12 p-left-0 booking_item">
                  <span
                    v-if="!editing"
                    :id="`${complaintId}_vue_to_follow_date_view`"
                  >
                    <label
                      v-if="issueDataInfo.to_follow.length !== 0"
                      class="font-weight-400"
                      >{{ issueDataInfo.to_follow }}
                    </label>
                    <label v-else class="font-weight-400"> --- </label>
                  </span>
                  <span
                    v-else
                    :id="`${complaintId}_vue_to_follow_date_input_section`"
                    class=""
                  >
                    <date-only-picker
                      :id="`${complaintId}_vue_to_follow_date_input`"
                      format="DD, d MM yyyy"
                      :class-list="[
                        'text_input',
                        'form-control only-picker-date text_field date_time m-bottom-5 sdatepicker',
                      ]"
                      name="to_follow"
                      v-model="issueDataInfo.to_follow"
                    >
                    </date-only-picker>
                  </span>
                </div>
              </div>
              <div class="col-md-12 p-left-0 p-top-15" v-if="editing">
                <button
                  class="btn octopus-btn-default-mobile octopus-btn-default save-changes"
                  href="javascript:void(0);"
                  type="submit"
                  v-show="!loading"
                >
                  Save
                </button>

                <img src="/pic/loading-4.gif" v-show="loading" />
              </div>
            </div>
          </form>

          <hr v-if="issueDataInfo.discussions.length !== 0" />

          <div
            class="row p-left-10"
            v-if="issueDataInfo.discussions.length !== 0"
          >
            <div class="col-md-12 p-left-0">
              <span class="reported-issue"> Resolution </span>
            </div>
            <div
              class="col-md-12 p-left-0 p-top-20"
              v-for="(discussion, index) in issueDataInfo.discussions"
            >
              <div class="col-md-12 p-left-0">
                <div class="col-md-1 p-left-0"></div>
                <div class="col-md-11 p-left-0">
                  <span class="user-wrote"
                    >{{ discussion.user_wrote }},{{
                      discussion.created_time
                    }}</span
                  >
                </div>
              </div>
              <div class="col-md-12 p-left-0">
                <div class="col-md-1 p-left-0">
                  <img
                    :src="
                      discussion.avatar
                        ? `${s3Path}${discussion.avatar}`
                        : getAvatarImage(discussion.avatar_img)
                    "
                    class="img-circle"
                    alt=""
                    width="30"
                  />
                </div>
                <div class="col-md-11 p-left-0">
                  <div class="user-message">
                    {{ discussion.user_message }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer new-design"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  deleteComplaint,
  getIssueInfo,
  issueEditParam,
  issueEditWithParam,
} from "@/modules/Booking/api/BookingViewTabs";
import ConfirmationPopup from "@/modules/common/components/ConfirmationPopup.vue";
import axios from "axios";
import { EventBus } from "@/events/event-bus";
import { inquiryEditSourceId } from "@/modules/common/api";
import PaymentInvoicePopup from "../../../../Payment/components/PaymentInvoicePopup.vue";

export default {
  name: "ViewIssuePopup",
  components: { PaymentInvoicePopup, ConfirmationPopup },
  props: {
    complaintId: 0,
    showViewIssuesPopup: 0,
    tabName: {
      type: String,
      default() {
        return null;
      },
    },
    loggedUser: {
      type: Object,
      default: () => ({}), // Default value is an empty object
    },
    s3Path: null,
  },
  data() {
    return {
      issueDataInfo: null,
      allComplaintTypes: [],
      statusColorData: null,
      editing: false,
      loading: false,
    };
  },
  methods: {
    getIssue() {
      getIssueInfo({
        id: this.complaintId,
      }).then((response) => {
        this.issueDataInfo = response.data.complaint;
        this.allComplaintTypes = response.data.allComplaintTypes;
        if (
          response.data.complaint &&
          response.data.complaint.complaint_status_row
        ) {
          this.statusColorData =
            "background-color:" +
            response.data.complaint.complaint_status_row.color +
            ";color:#FFFFFF";
        }
      });
    },
    showDiscussions() {
      //make emit event bus to get
      $(this.$refs["viewIssuePopupModal"]).modal("hide");
      EventBus.$emit("showDiscussions", this.complaintId);
    },
    IssueDiscussionPopup(complaintId, process1 = "", process2 = "") {
      let IssueDiscussionPopupUrl = false;
      if (process2) {
        IssueDiscussionPopupUrl = `/booking/discussion/${complaintId}/${process1}/complaint?process2=${process2}`;
      } else {
        IssueDiscussionPopupUrl = `/booking/discussion/${complaintId}/${process1}/complaint`;
      }
      if (IssueDiscussionPopupUrl) {
        window.popupi("Issue Discussion", IssueDiscussionPopupUrl);
      }
    },
    complaintEmailReplay(complaintId, customer_id) {
      let IssueDiscussionPopupUrl = `/get-canned-responses-form/customer/email/complaint/${complaintId}/${customer_id}/complaint_reply`;
      if (IssueDiscussionPopupUrl) {
        window.popupi("Email Acknowledgement", IssueDiscussionPopupUrl);
      }
    },
    deleteForEver(complaintId) {
      deleteComplaint(complaintId).then((response) => {
        if (response.status == 200) {
          $(this.$refs["viewIssuePopupModal"]).modal("hide");
          EventBus.$emit("complaintDeleted", complaintId);
          $.notify("Deleted successfully", "success");
        }
      });
    },
    toggleEdit() {
      this.editing = !this.editing;
    },
    saveEditing() {
      const form = this.$refs.issueEditForm;
      const formData = new FormData(form);
      this.loading = true;
      issueEditParam(this.complaintId, formData)
        .then((response) => {
          $.notify(response.data.message, response.data.type);
          this.editing = !this.editing;
          this.loading = false;
          this.getIssue();
          EventBus.$emit("editComplaint");
        })
        .catch((error) => {
          // Handle any errors here
        });
    },
    Invoice_Preview_Data(id = 0, merged_invoice_id = 0) {
      if (merged_invoice_id === null) {
        merged_invoice_id = 0;
      }

      window.popupi(
        "Invoice Preview",
        `/invoice/preview/${id}?booking_id=${id}&merged_invoice_id=${merged_invoice_id}`
      );
    },
    getAvatarImage(avatar) {
      return "data:image/png;base64," + avatar;
    },
    closeModal() {
      $(this.$refs["viewIssuePopupModal"]).modal("hide");
    },
    issueEditWithParamFunction(paramName, paramValue) {
      issueEditWithParam(this.complaintId, "paramName", paramValue)
        .then((response) => {
          $.notify(response.data.message, response.data.type);
        })
        .catch((error) => {
          // Handle any errors here
        });
    },
  },
  computed: {
    color() {
      return this.statusColorData;
    },
  },
  watch: {},
  mounted() {
    this.$nextTick(function () {
      EventBus.$on("refetchIssue", (value) => {
        if (this.complaintId) {
          this.getIssue();
        }
      });
    });

    EventBus.$on("statuschange", (value) => {
      this.signatureRemoved = false;
    });
    if (this.complaintId) {
      this.getIssue();
      if (this.showViewIssuesPopup) {
        setTimeout(() => {
          $(`#issue-popup${this.showViewIssuesPopup}${this.tabName}`).modal(
            "show"
          );
        }, 4000);
      } else {
        console.log("showViewIssuesPopup and complaintId do not match");
      }
    }
  },
};
</script>
<style scoped>
.modal-content {
  cursor: auto;
}
.modal {
  overflow: auto !important;
}
.border-0 {
  border: unset !important;
}
.bg-unset {
  background-color: unset !important;
}
.bg-unset:visited,
.bg-unset:focus,
.bg-unset:active {
  background-color: unset !important;
}

.status-label {
  color: #ffffff !important;
  border-radius: 100px !important;
  padding: 2px 8px 4px 8px !important;
}

.labels-font {
  font-size: 14px;
  font-weight: 700;
  color: #2e4051;
}

.font-family-Roboto {
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  color: #2e4051;
}

.position-status-invoice-modal {
  position: relative;
  bottom: 4px;
}

.pair_btn_new_uniq .create-btn {
  border: none !important;
}

.cursor-pointer {
  cursor: pointer;
}

.modal-header.new-design {
  border-bottom: unset;
}

.has-error .form-control {
  border-color: #a94442 !important;
}

.modal-header.new-design .modal-title {
  font-family: "Roboto", serif;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 24px;
  color: #2e4051;
  display: inline;
}

.modal-footer.new-design {
  border-top: unset;
}

.close-icon {
  float: right;
}

.clickable {
  cursor: pointer;
}

.booking_title {
  font-family: Roboto;
  font-size: 14px;
  font-weight: 600;
  line-height: 32px;
  text-align: left;
  color: #2e4051;
}

.booking_item {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #2e4051;
}

.figma-switch {
  padding: 2px 0 !important;
}

.save-btn {
  padding: 4px 6px !important;
}

.cancel-btn {
  padding: 4px 7px !important;
}

.status-content {
  background-color: #f9f9fa;
  padding: 20px 0 20px 0;
  border-radius: 12px;
}
.text-decoration-none {
  text-decoration: none;
}
.color-blue {
  color: #008cfa;
}
.position-relative {
  position: relative;
}
.top-4 {
  top: 4px;
}
.reported-issue {
  font-family: Roboto;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  text-align: left;
}
.save-changes {
  width: 67px;
  height: 48px;
  padding: 12px 16px 12px 16px;
  border-radius: 8px;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
}
.issue-type-select {
  height: 48px;
  border-radius: 8px;
}
.user-message {
  background-color: #f5f5f6;
  padding: 5px 12px;
  border-radius: 20px;
  font-family: Roboto;
  font-size: 16px;
  /* font-weight: 400; */
  /* line-height: 24px; */
  /* text-align: left; */
  color: #2e4051;
}
.user-wrote {
  font-family: Roboto;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  color: rgba(46, 64, 81, 1);
  margin-left: 10px;
  margin-bottom: 5px;
  display: inline-block;
}
@media (max-width: 768px) {
}

@media (min-width: 768px) and (max-width: 1023px) {
}
</style>
<style>
.booking_item .owner-tom-selector {
  background-color: #f9f9fa !important;

}
</style>
